import React, {Component} from 'react';
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarAlt, faCheckDouble, faDownload, faSlidersH, faTimes, faTruck} from '@fortawesome/free-solid-svg-icons'
import API from "../../services/API";
import { DatePicker } from "react-persian-datepicker";
import moment from "moment-jalaali";
import {toast} from "react-toastify";
import Toast from "../Common/Toast";
import Loading from "../Common/Loading";

let pages = [];
for(let p = 1 ; p < 50 ; p++){
    pages[p] = p;
}
const styles = {
    calendarContainer: 'calendarContainer',
    dayPickerContainer: 'dayPickerContainer',
    monthsList: 'monthsList',
    daysOfWeek: 'daysOfWeek',
    dayWrapper: 'dayWrapper',
    selected: 'selected',
    heading: 'heading',
    prev: 'prev',
    next: 'next',
    title: 'title',

}
class Home extends Component {
    state = {
        requests : [],
        trackingCode : '',
        statuses : [],
        drivers : [],
        status: 0,
        date_from:moment().subtract(7,'days'),
        date_to: moment(),
        isLoaded:false,
        companyName : '',
        showModal : false,
        count : 0,
        searchButtonLabel : 'فیلتر'

    }
    onSearchTrackingCode = (event) => {
        this.setState({
            trackingCode:event.target.value
        })
        if(event.target.value.length > 2) {
            const request = {
                proccess_for : 'Expert',
                tracking_code : event.target.value,
                small_cargo : 0
            }
            API.completed(request)
                .then((response) => {
                    const requests = response.results.requests;
                    const count = response.results.count;
                    this.setState({requests,count})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        if(event.target.value.length  < 1) {
            const request = {
                small_cargo : 0

            }
            API.completed(request)
                .then((response) => {
                    const requests = response.results.requests;
                    const count = response.results.count;
                    this.setState({requests , count})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
    }
    advancedSearch = (event) => {
        this.setState({searchButtonLabel : 'در حال جستجو'})
            const request = {
                company_name : this.state.companyName,
                status_id: this.state.status,
                date_from: this.state.date_from,
                date_to: this.state.date_to,
                small_cargo : 0
            }
            API.completed(request)
                .then((response) => {
                    const requests = response.results.requests;
                    const count = response.results.count;
                    this.setState({requests , count,showModal : false , searchButtonLabel : 'فیلتر  '})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });

    }
    onGiftPress = (id) => {
        this.setState({ isLoaded : false})

            const request = {
                request_id : id,
                small_cargo : 0
            }
            API.gifts(request)
                .then((response) => {
                    toast.success(response.user_message)
                    setTimeout (() => {
                        const request = {

                            page: this.props.match.params.page ? this.props.match.params.page : 1,

                            company_name : this.state.companyName,
                            status_id: this.state.status,
                            date_from: this.state.date_from,
                            date_to: this.state.date_to,
                            small_cargo : 0
                        }
                        API.completed(request)
                            .then((response) => {
                                const requests = response.results.requests;
                                const count = response.results.count;
                                this.setState({requests , count , isLoaded : true})
                            })
                            .catch((error) => {
                                //   toast.error(error.response.data.user_message);
                            });

                    },500)
                })
                .catch((error) => {
                    toast.error(error.response.data.user_message);
                });

    }

    filterOpen = () => {
        document.getElementsByClassName('persian-date')[0].readOnly = true;
        document.getElementsByClassName('persian-date')[1].readOnly = true;
    }
    render() {
        return (
            <React.Fragment >
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast  />
                <Actionbar noBack={1} title=' لیست درخواست ها'/>
                {
                    this.state.showModal &&
                    <section className="container-fluid modal-bg max-w-lg">
                        <div className="row rtl">
                            <div className="col-12 ">
                                <div className="row modal-card "
                                onFocus={this.filterOpen}
                                >
                                    <div className="col-12 border-bottom text-center my-2 text-primary small">
                                        جستجوی پیشرفته درخواست ها
                                    </div>
                                    <div className="col-12 super-small-2 text-secondary mt-2">
                                        <FontAwesomeIcon icon={faCalendarAlt}  className='px-2'/>
                                        تاریخ ثبت درخواست:
                                    </div>
                                    <div className="col-6 super-small">
                                        <span className='float-right'>
                                            از:
                                        </span>
                                        <DatePicker
                                            calendarStyles={styles}
                                            inputFormat="jYYYY/jM/jD"

                                            className="form-control persian-date super-small w-75 float-left"
                                            value={this.state.date_from}

                                            onChange={(value)=>this.setState({'date_from' : value})}
                                        />
                                    </div>
                                    <div className="col-6 super-small">
                                        <span className='float-right'>
                                            تا:
                                        </span>
                                        <DatePicker
                                            calendarStyles={styles}
                                            inputFormat="jYYYY/jM/jD"
                                            className="form-control persian-date super-small w-75 float-left"
                                            value={this.state.date_to}
                                            onChange={(value)=>this.setState({'date_to' : value})}
                                        />
                                    </div>

                                    <div className="col-12 mt-2">
                                        <div className="form-floating super-small-2">
                                            <input type="text" className="form-control height-40" id="floatingInput"
                                                   placeholder="جستجو  شرکت"
                                                   onChange={
                                                       (val) => {
                                                           this.setState({
                                                               companyName : val.target.value
                                                           })
                                                       }
                                                   }
                                                   value={this.state.companyName}
                                            />
                                            <label htmlFor="floatingInput"> نام شرکت</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group ">
                                            <select className="form-select w-100 super-small py-2 bg-light" id="statuses" name="statuses"
                                                    aria-label=" label select example"
                                                    value={this.state.status}
                                                    onChange={(val) =>  {
                                                        this.setState({status : val.target.value});
                                                    }} >
                                                <option value={0}>
                                                     وضعیت
                                                </option>
                                                {this.state.statuses.map(st => {
                                                    return (
                                                        <option value={st.id} key={st.id} style={{color:st.color}}>
                                                            {st.title}
                                                        </option>
                                                    )
                                                })}
                                            </select>
                                        </div>

                                    </div>
                                     <div className="col-6 my-2 ">
                                        <button className='btn bg-primary text-white
                                        super-small-2 w-100 p-2'
                                                onClick={this.advancedSearch}
                                        >
                                            <FontAwesomeIcon icon={faSlidersH} className='ms-2'/>
                                            {this.state.searchButtonLabel}
                                        </button>
                                    </div>
                                    <div className="col-6 my-2">
                                        <button className='btn bg-secondary text-white super-small-2 w-100 p-2 '
                                                onClick={() => {
                                                    this.setState({showModal: false})
                                                }}
                                        >
                                            <FontAwesomeIcon icon={faTimes} className='ms-2'/>
                                            انصراف
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
                <section className="container my-5 py-4 ">



                    <div className="row alert alert-secondary rtl super-small-2 p-0 py-1">
                        <div className="col-4 text-center px-1 "
                        onClick={() => {
                            this.setState({
                                showModal : true
                            });

                        }}
                        >
                            <span className='btn btn-primary super-small-2 w-100'>
                                <FontAwesomeIcon icon={faSlidersH} className='ps-1' />
                                فیلتر پیشرفته
                            </span>

                        </div>
                        <div className="col-8 text-left">
                            <span className='mx-3'>برو به:</span>
                            <select onChange={(val) => {window.location.assign("/home/" + val.target.value)}} className='w-50 text-center bg-primary text-white small rounded' >
                                {
                                    pages.map (p => {
                                        return (
                                            <option value={p}  selected={parseInt(this.props.match.params.page) === p ? 'selected' : ''}
                                            >
                                                صفحه
                                                &nbsp;
                                                {p}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row mb-2 rtl">
                        <div className="col-6 text-center super-small text-secondary pt-2">
                            تعداد کل :
                            &nbsp;
                            {this.state.count}
                            &nbsp;
                            درخواست
                        </div>
                        <div className="col-6">
                            <div className="form-floating super-small-2">
                                <input type="number" className="form-control height-40" id="floatingInput"
                                       placeholder="جستجو کد رهگیری"
                                       onChange={this.onSearchTrackingCode}
                                       value={this.state.trackingCode}
                                />
                                <label htmlFor="floatingInput">جستجو کد رهگیری</label>
                            </div>
                        </div>
                    </div>
                    <div className="row px-2">
                        {
                            this.state.requests.map (request => {
                                return (
                                    <div className="col-12 rtl mb-2 request-row pb-2 bg-light "

                                         key={request.id}
                                    >
                                        <div className="row  mx-2 py-2">
                                            <div className="col-6 badge badge-info badge-pill bg-secondary float-right ">{request.company.title}

                                                <span className='small pe-2'>{request.loading_date}
                                                    &nbsp;
                                                    <FontAwesomeIcon icon={faCalendarAlt}/></span>
                                               </div>
                                            <div className="col-6 text-left super-small-2" style={{color:request.status.color}}>{request.status.title}</div>


                                            <div className="col-12 mt-2 super-small">
                                                <FontAwesomeIcon icon={faDownload} />
                                                &nbsp;
                                                {request.unloading_addresses[0] && request.unloading_addresses[0].title}
                                                &nbsp;
                                                {request.unloading_addresses[0] && request.unloading_addresses[0].address.substring(0, 25)} ...
                                            </div>
                                            <div className="col-12 mt-3 ">
                                                <div className='float-left text-dark'>

                                              <span className=' badge bg-dark bg-opacity-25 small'>
                                                    {request.tracking_code}
                                                </span>

                                                </div>
                                                <div className='super-small-2'>
                                                    <FontAwesomeIcon icon={faTruck} className='text-secondary' />
                                                    &nbsp;
                                                    {request.car_type.parent}
                                                    &nbsp;
                                                    -
                                                    &nbsp;
                                                    {request.car_type.title}
                                                    &nbsp;&nbsp;
                                                    {request.driver.last_name ?

                                                        <strong>
                                                            (
                                                            {request.driver.last_name}
                                                            )
                                                        </strong>
                                                        : ''
                                                    }




                                                </div>

                                            </div>
                                            <div className="col-12 mt-3 p-2 text-center">
                                                <button className='btn btn-success w-100 super-small-2'
                                                onClick={() => {
                                                    this.onGiftPress(request.id)
                                                }}
                                                >
                                                    <FontAwesomeIcon icon={faCheckDouble} className='ms-2 text-warning' />
                                                    تایید درخواست و واریز پاداش راننده و کارشناس
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )} )
                        }
                    </div>
                </section>

                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount() {
        const request = {

            page: this.props.match.params.page ? this.props.match.params.page : 1,

            company_name : this.state.companyName,
            status_id: this.state.status,
            date_from: this.state.date_from,
            date_to: this.state.date_to,
            small_cargo : 0
        }
        API.completed(request)
            .then((response) => {
                const requests = response.results.requests;
                const count = response.results.count;
                this.setState({requests , count , isLoaded : true})
            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });

        API.getStatuses()
            .then((response) => {
                const statuses = response.results.statuses;
                this.setState({statuses})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });




    }
}

export default Home;